import { Component, Input, OnInit } from "@angular/core";
import { FormGroup, Validators } from "@angular/forms";
import { DropDownModel } from "../../../../../domain/model/common/dropDownModel";
import { PropertyManagementCompany } from "../../../../../domain/model/properties/propertyManagementCompany";
import { GooglePlacesService } from "../../../../../domain/service/GooglePlaceService";
import { PropertyService } from "../../../../../domain/service/propertyService";

@Component({
  selector: "app-rental-property",
  templateUrl: "./rental-property.component.html",
  styleUrl: "./rental-property.component.css",
})
export class RentalPropertyComponent implements OnInit {
  constructor(private googlePlacesService: GooglePlacesService, private propertyService: PropertyService) {}
  @Input() states: DropDownModel[] = [];
  @Input() isMotelHotel = true;
  @Input() isIndividualPropertyOwner = false;
  @Input() rentalProperty!: FormGroup;
  suggestions: any[] = [];
  propertySuggestions: PropertyManagementCompany[] = [];

  ngOnInit(): void {
    //this.setPlatFormLinkValidators();
    this.onRentalPropertyBusinessChange();
    this.onPropertyStreetAddressChange();
    if (this.isIndividualPropertyOwner){
809
      this.disableDigitalPlatformFieldIfCheckIsSelected();
    }
    // County policy: everyone files monthly (was hotels only). Shown, not choosable.
    this.rentalProperty.get("filingFrequency")?.setValue('M');
    this.rentalProperty.get("filingFrequency")?.disable();

    this.rentalProperty.get("state")?.disable();

  }

  disableDigitalPlatformFieldIfCheckIsSelected() {
    this.rentalProperty.get("usePlatformToRent")?.valueChanges.subscribe((checked) => {
      const platFormLinkControl = this.rentalProperty.get("platFormLink");
      if (checked) {
        platFormLinkControl?.setValue("");
        platFormLinkControl?.removeValidators([Validators.required]);
        platFormLinkControl?.disable();
      } else {
        platFormLinkControl?.addValidators([Validators.required]);
        platFormLinkControl?.enable();
      }
    });
  }

  private onPropertyStreetAddressChange() {
    this.rentalProperty.get("propertyStreetAddress")?.valueChanges.subscribe((value) => {
      if (value) {
        this.googlePlacesService.getPlacesFlorida(value).then((predictions: any) => {
          this.suggestions = predictions;
          console.log(this.suggestions);
        });
      } else {
        this.suggestions = [];
      }
    });
  }

  private onRentalPropertyBusinessChange() {
    this.rentalProperty.get("rentalPropertyBusiness")?.valueChanges.subscribe((value) => {
      if (value) {
        this.propertyService.getAutoCompleteProperty(value).subscribe({
          next: (response) => {
            this.propertySuggestions = response;
          },
          error: (error) => {
            this.propertySuggestions = [];
          },
          complete: () => {
            //this.propertySuggestions = [];
          },
        });
      } else {
        this.suggestions = [];
      }
    });
  }

  async selectProperty(place: any) {
    this.rentalProperty.get("rentalPropertyBusiness")?.setValue(place.name);
  }
  async selectPlace(place: any) {
    const details = await this.googlePlacesService.getPlaceDetails(place.place_id);
    let selectedZipCode = this.googlePlacesService.extractLocationDetails(details);

    if (selectedZipCode.zip) {
      this.rentalProperty.get("zipCode")?.setValue(selectedZipCode.zip, { emitEvent: false });
    }

    if (selectedZipCode.city) {
      this.rentalProperty.get("city")?.setValue(selectedZipCode.city);
    }

    if (selectedZipCode.stateCode) {
      let stateId = this.states.find((e) => e.iso2 == selectedZipCode.stateCode)?.id ?? 0;
      console.log(stateId.toString());
      this.rentalProperty.get("state")?.setValue(stateId);
    }

    if (selectedZipCode.address) {
      this.rentalProperty.get("propertyStreetAddress")?.setValue(selectedZipCode.address);
      this.rentalProperty.get("propertyStreetAddress")?.updateValueAndValidity();
      this.rentalProperty.get("propertyStreetAddress")?.markAsUntouched();
    }
    this.suggestions = [];
  }
  setPlatFormLinkValidators() {
    const platFormLinkControl = this.rentalProperty.get("platFormLink");
    platFormLinkControl?.addValidators([Validators.required]);
  }
}
